import React, { Component } from "react";
import { Icon, Header, Button, Tab, Modal } from "semantic-ui-react";
import { datapop } from "../actions/data-populate";
import BillingInfo from "../components/customerinfo/billing";
import { getpath } from "../actions/get-path";
import { getAction } from "../actions/get-action";
import { bindActionCreators } from "redux";
import { app } from "../index";
import { connect } from "react-redux";
import Location from "../components/customerinfo/location";
import PmInfo from "../components/customerinfo/pm";
import ProjectInfo from "../components/customerinfo/project";
import CompanyInfo from "../components/customerinfo/company";
import { updateservice, createservice } from "./../services/crudservice";
import { custdrop } from "./../services/gendropdown";
class CustomerInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: "",
      deletepayload: [],
      deleteservice: "",
      showdeletemodal: false
    };
  }
  componentWillMount() {
    this.setState({ activeIndex: this.props.params.tabindex });
  }

  gendeletemessage() {
    return this.state.deletepayload.map((payload, index) => {
      return <p>{payload.title}</p>;
    });
  }

  handleitemupdate(payload, title, service) {
    this.setState({
      deletepayload: payload,
      deleteservice: service,
      showdeletemodal: true
    });
  }

  componentDidMount() {
    this.props.getpath("Customer Info", "fighter jet");
  }
  handleupdateitems(payload, id, service) {
    updateservice(service, payload, id);
  }

  handledeleteitems() {
    let deleteservice = app.service(this.state.deleteservice);
    this.state.deletepayload.map(item => {
      deleteservice.remove(item.id);
    });
    this.setState({
      showdeletemodal: false
    });
    window.location.reload();
  }
  handleRangeChange(e) {
    this.setState({ activeIndex: e.target.value });
  }
  handleTabChange(e, activeIndex) {
    this.setState({ activeIndex: activeIndex });
  }

  render() {
    const panes = [
      {
        menuItem: "Billing Contacts",
        render: () => (
          <BillingInfo
            billingitems={this.props.custinfo.billing}
            handleDelete={(payload, service) => {
              console.log(service);
              this.setState({
                deletepayload: payload,
                deleteservice: service,
                showdeletemodal: true
              });
            }}
            create={payload => createservice("billing", payload)}
            handleupdateitems={(payload, id, service) =>
              this.handleupdateitems(payload, id, service)
            }
          />
        )
      },
      {
        menuItem: "Company",
        render: () => (
          <CompanyInfo
            companyitems={this.props.custinfo.customers}
            handleDelete={(payload, service) => {
              console.log(service);
              this.setState({
                deletepayload: payload,
                deleteservice: service,
                showdeletemodal: true
              });
            }}
            create={payload => createservice("customers", payload)}
            handleupdateitems={(payload, id, service) =>
              this.handleupdateitems(payload, id, service)
            }
          />
        )
      },
      {
        menuItem: "Location",
        render: () => (
          <Location
            locations={this.props.custinfo.locations}
            create={payload => createservice("location", payload)}
            handleDelete={(payload, service) => {
              this.setState({
                deletepayload: payload,
                deleteservice: service,
                showdeletemodal: true
              });
              console.log("handleDelete");
            }}
            handleupdateitems={(payload, id, service) =>
              this.handleupdateitems(payload, id, service)
            }
          />
        )
      },
      {
        menuItem: "Project",
        render: () => (
          <ProjectInfo
            projectitems={this.props.custinfo.programs}
            create={payload => createservice("programs", payload)}
            handleDelete={(payload, service) => {
              this.setState({
                deletepayload: payload,
                deleteservice: service,
                showdeletemodal: true
              });
            }}
            handleupdateitems={(payload, id, service) =>
              this.handleupdateitems(payload, id, service)
            }
          />
        )
      },
      {
        menuItem: "ProjectManager",
        render: () => (
          <PmInfo
            customers={custdrop(this.props.custinfo.customers)}
            pmitems={this.props.custinfo.engassigned}
            wods={this.props.wods}
            create={payload => createservice("engassigned", payload)}
            handleDelete={(payload, service) => {
              console.log(service);
              this.setState({
                deletepayload: payload,
                deleteservice: service,
                showdeletemodal: true
              });
            }}
            handleupdateitems={(payload, id, service) =>
              this.handleupdateitems(payload, id, service)
            }
          />
        )
      }
    ];
    const tabs = ["billing", "company", "location", "project", "pm"];
    if (
      this.props.custinfo.customers.length &&
      this.props.custinfo.engassigned
    ) {
      return (
        <div className="CustomerInfo">
          <Tab
            panes={panes}
            menu={{ secondary: true, pointing: true }}
            defaultActiveIndex={tabs.indexOf(this.props.params.tabindex)}
          />
          <Modal open={this.state.showdeletemodal} basic size="small">
            <Header
              icon="archive"
              content="Are you sure you would like to delete these items?"
            />
            <Modal.Content> {this.gendeletemessage()}</Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="red"
                inverted
                onClick={() => this.setState({ showdeletemodal: false })}
              >
                <Icon name="remove" /> No
              </Button>
              <Button
                color="green"
                inverted
                onClick={() => this.handledeleteitems()}
              >
                <Icon name="checkmark" /> Yes
              </Button>
            </Modal.Actions>
          </Modal>
        </div>
      );
    } else {
      return <div />;
    }
  }
}
function mapStateToProps(state) {
  return {
    custinfo: state.custinfo,
    wods: state.workorders.derivitives,
    jobs: state.jobs.assignedjobs,
    dates: state.dates.thisweek,
    myinfo: state.myinfo.employeeinfo
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      datapop: datapop,
      getpath: getpath,
      get: getAction
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(CustomerInfo);



// WEBPACK FOOTER //
// ./src/containers/CustInfo.js